import { useRef, useEffect, useState, createRef, useMemo } from "react";


export default function ContainedImages({
  currentFloor,
  floors,
  setImg,
  containerStyles = {},
  allImagesLoaded,
  setAllImagesLoaded
}) {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });
  const container = useRef();
  const [finishedLoadingImages, setFinishedLoadingImages] = useState({});

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [])

  useEffect(() => {
    setFinishedLoadingImages((finishedLoadingImages) => {
      return floors.reduce((finishedLoadingImages, { id }) => {
        if(finishedLoadingImages[id] === undefined) {
          finishedLoadingImages[id] = {
            loaded: false,
            ref: createRef()
          };
        }
        return finishedLoadingImages;
      }, finishedLoadingImages);
    })
  }, [floors])

  useEffect(() => {
    setAllImagesLoaded(() => Object.keys(finishedLoadingImages).length !== 0 &&
      Object.values(finishedLoadingImages).every(({ loaded }) => loaded)
    );
  }, [finishedLoadingImages])

  useEffect(calculateMeasurementsAndConfigureTheImg, [allImagesLoaded, currentFloor, windowSize]);

  function calculateMeasurementsAndConfigureTheImg() {
    if (!allImagesLoaded || !currentFloor) return;

    const imgRef = finishedLoadingImages[currentFloor.id].ref;
    const containerClientWidth = container.current?.clientWidth;
    const containerClientHeight = container.current?.clientHeight;
    const containerRatio = containerClientWidth / containerClientHeight;
    const naturalWidth = imgRef.current?.naturalWidth;
    const naturalHeight = imgRef.current?.naturalHeight;
    const imgRatio = naturalWidth / naturalHeight;
    const ratioIsFIne = imgRatio === containerRatio;
    let spacingVertical = containerClientHeight - containerClientWidth / imgRatio;
    let spacingHorizontal = containerClientWidth - containerClientHeight * imgRatio;
    setImg({
      naturalWidth,
      naturalHeight,
      clientWidth: imgRef.current?.clientWidth,
      clientHeight: imgRef.current?.clientHeight,
      spacingHorizontal,
      spacingVertical,
    });
  }

  function handleImageLoad(event, { id }) {
    setFinishedLoadingImages((finishedLoadingImages) => {
      const newFinishedLoadingImages = { ...finishedLoadingImages };
      newFinishedLoadingImages[id].loaded = true;
      return newFinishedLoadingImages;
    });
  }

  // TODO: every ap is slighly more down than they should be for some reason
  // There is a bit of extra bottom space when changing display to inline which is the default img tag display
  // maybe there's something there?
  return (
    <div
      ref={container}
      style={{
        height: "100%",
        width: "100%",
        position: "relative",
        ...containerStyles
      }}
    >
      {floors.map(({ id, url }, index) => {
        return (
          <img
            alt="mapa"
            key={index}
            src={url}
            ref={finishedLoadingImages[id]?.ref}
            onLoad={(event) => {
              handleImageLoad(event, { id });
            }}
            style={{
              width: "100%",
              objectFit: "contain",
              height: "100%",
              objectPosition: "top",
              display: currentFloor && id === currentFloor.id ? "block" : "none"
            }}
          />
        );
      })}
    </div>
  );
}
